import React from "react";
import "./ResendConfirmation.css";
import { Form, Layout, Row, Col, Input, Button, message } from "antd";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";

import STUDENT_RESEND_CONFIRMATION from "graphql/mutations/StudentResendConfirmation";
import useErrors from "hooks/useErrors";
import ErrorAlerting from "common/error_alerting";

const { Content } = Layout;

function ResendConfirmation() {
  const [resendConfirmationForm] = Form.useForm();

  const { t } = useTranslation("login");
  const [resendConfirmation] = useMutation(STUDENT_RESEND_CONFIRMATION);
  const { errors, handleError, closeError } = useErrors();

  const handleResendConfirmation = async (values: any) => {
    try {
      const {
        data: {
          studentResendConfirmationWithToken: { message: successMessage },
        },
      } = await resendConfirmation({
        variables: {
          ...values,
          redirectUrl: `${window.location.origin}/confirm-registration`,
        },
      });

      message.success(successMessage);
      resendConfirmationForm.resetFields();
    } catch (e) {
      handleError(e);
    }
  };

  return (
    <Content className="content-container login-container">
      <ErrorAlerting errors={errors} onClose={closeError} />
      <div className="login-card">
        <div className="card-title">
          {t("Reconfirm Your Email").toLocaleUpperCase()}
        </div>
        <Form
          name="resendConfirmation"
          form={resendConfirmationForm}
          onFinish={(values) => handleResendConfirmation(values)}
        >
          <Form.Item
            name="email"
            rules={[{ required: true, message: "Email is required." }]}
          >
            <Input
              className="input"
              type="email"
              placeholder={t("Enter email to receive instructions")}
              name="email"
              size="large"
            />
          </Form.Item>
          <Form.Item>
            <Row gutter={16}>
              <Col span={12}>
                <Button
                  className="log-in-button"
                  type="primary"
                  htmlType="submit"
                >
                  {t("Submit").toLocaleUpperCase()}
                </Button>
              </Col>
              <Col span={12}>
                <div className="login-prompt">
                  <span className="login-prompt-text">
                    {t("Not a member")}?
                  </span>
                  <a
                    href="https://flexiclasses.com"
                    target="_blank"
                    className="linked-text"
                  >
                    {t("Register here").toLocaleUpperCase()}
                  </a>
                </div>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </div>
    </Content>
  );
}

export default ResendConfirmation;
